import { LearningCenterEducationalResource } from "./types";
import { typedQuery } from "../../../typed-query";

/**
 * @returns all learning center educational resources, ordered by date descending
 */
export const intercomComLearningCenterEducationalResourceQuery = typedQuery<
  LearningCenterEducationalResource[]
>(`
*[_type == "intercomComLearningCenterEducationalResource"] | order(_createdAt desc) {
  _id,
  title,
  excerpt,
  url,
  "mainImage": mainImage{ alt, "asset": asset->{ url, metadata } }
}`);
